import { Drawer as DrawerBase } from '@base-ui/react/drawer'
import clsx from 'clsx'
import React from 'react'

import { Alignment } from '@Components/Drawer/types'
import { getOverlayContainer } from '@Components/Overlay/useOverlayContainer'

import styles from './Drawer.module.scss'

const swipeDirectionMap: Record<Alignment, 'up' | 'down' | 'left' | 'right'> = {
  top: 'up',
  bottom: 'down',
  left: 'left',
  right: 'right',
  center: 'down',
  full: 'right',
}

export const Drawer = ({
  alignment = 'right',
  children,
  disableBackdrop = false,
  loading = false,
  triggerRender,
  ...props
}: React.ComponentProps<typeof DrawerBase.Root> & {
  alignment?: Alignment
  children?: React.ReactNode
  disableBackdrop?: boolean
  loading?: boolean
  triggerRender?: React.ComponentProps<typeof DrawerBase.Trigger>['render'] | false
}) => (
  <DrawerBase.Root {...props} swipeDirection={swipeDirectionMap[alignment]}>
    {triggerRender !== false && (
      <DrawerBase.Trigger className={styles.button} disabled={loading} render={triggerRender}>
        {loading ? 'Loading...' : 'Open'}
      </DrawerBase.Trigger>
    )}

    <DrawerBase.Portal container={getOverlayContainer()}>
      {!disableBackdrop && <DrawerBase.Backdrop className={styles.backdrop} />}

      <DrawerBase.Viewport className={clsx(styles.viewport, styles[alignment])}>
        <DrawerBase.Popup className={styles.popup}>
          {children}
        </DrawerBase.Popup>
      </DrawerBase.Viewport>
    </DrawerBase.Portal>
  </DrawerBase.Root>
)

Drawer.createHandle = DrawerBase.createHandle
